/**
 * Utilitário de navegação global
 * Permite navegação programática tanto dentro quanto fora do contexto React Router
 */

let navigateFunction = null;

/**
 * Registra a função de navegação do React Router
 * Deve ser chamado no componente raiz da aplicação
 * @param {Function} navigate - Função navigate do React Router
 */
export const registerNavigation = (navigate) => {
  navigateFunction = navigate;
};

/**
 * Navega para uma rota específica
 * Usa React Router se disponível, caso contrário usa window.location
 * @param {string} path - Caminho para navegar
 * @param {Object} options - Opções de navegação (replace, state, etc)
 */
export const navigateTo = (path, options = {}) => {
  if (navigateFunction) {
    navigateFunction(path, options);
  } else {
    // Fallback para window.location quando React Router não está disponível
    if (options.replace) {
      window.location.replace(path);
    } else {
      window.location.href = path;
    }
  }
};

/**
 * Navega para a página de login
 */
export const navigateToLogin = () => {
  navigateTo('/login', { replace: true });
};

/**
 * Navega para a página de erro de acesso negado
 */
export const navigateToAccessDenied = () => {
  navigateTo('/errors/access-denied', { replace: true });
};

